import { PROCEDURE_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useProcedureParamsList } from './hook';
import { ProcedureParamsListProps } from './props';

export const ProcedureParamsList = ({ filters }: ProcedureParamsListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useProcedureParamsList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item, event) => {
                if (!(event.target as Element).closest('.no-click-cell')) {
                    window.open(`${PROCEDURE_DETAIL}/${item.row.id}`, '_blank');
                }
            }}
        />
    );
};
